/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { ADAPTIVE_SMALL_BREAKPOINT as o, ADAPTIVE_MEDIUM_BREAKPOINT as a } from "../constants/main.mjs";
const d = { small: o, medium: a }, t = e.createContext(d), n = () => e.useContext(t);
t.displayName = "KendoReactAdaptiveModeContext";
export {
  t as AdaptiveModeContext,
  d as defaultValue,
  n as useAdaptiveModeContext
};
